import type { ReportingPeriod } from "@cle/models/reportingPeriod";

export type IndberetningDetailVariant = "reported" | "open" | "current";

/**
 * Afgør hvilken visning en efteruddannelsesperiode skal have.
 *
 * Tidligere åbnede 7-trins-flowet på `hasOpenReport || deadline != null`. Både `openReportId`
 * og `deadline` udledes af den samme indberetning uanset dens status, så en indberetning, der
 * IKKE er en kladde (fx slettet) men stadig har en frist og ingen indsendt-dato, åbnede flowet.
 * Brugeren kom hele vejen til sidste klik og fik så backendens rå EF-tekst
 * ("Sequence contains no elements") som en 400. Nu kræves en reel kladde.
 */
export const resolveIndberetningDetailVariant = (
  reportingPeriod: Pick<
    ReportingPeriod,
    "hasBeenReported" | "hasOpenReport" | "openReportId"
  >,
): IndberetningDetailVariant => {
  if (reportingPeriod.hasBeenReported) {
    return "reported";
  }

  if (reportingPeriod.hasOpenReport && reportingPeriod.openReportId) {
    return "open";
  }

  return "current";
};
